import React, {useEffect, useRef} from "react";
import {
  Typography,
  Divider,
  Card,
  CardHeader,
  CardContent,
  IconButton,
  styled
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import tooltipCalender from "../../assets/images/icons/tooltip-clender.svg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useJoyride } from "utilities/JoyrideProvider";


const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#EAFFD8",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#EAFFD8",
    color: "#2B2B2B",
    width: "1000px",
    boxShadow: "4px 20px 36px 8px #1D1D1B14",
    border: "1px solid #164A1A",
    padding: 0,
  },
}));



const InfoDataTooltip = ({ data }) => {
  const elementRef = useRef(null);
  const { setStepReadyState, joyrideState } = useJoyride();
  const readMore = (value) => {
    if (process.env.REACT_APP_ORIGIN === "http://localhost:3000/") {
      return `${process.env.REACT_APP_ORIGIN}pages/glossary/#${value}`;
    } else {
      return `${process.env.REACT_APP_ORIGIN}/pages/glossary/#${value}`;
    }
  };

  
  useEffect(() => {
    if(joyrideState.currentAction !== 'skip' || joyrideState.currentAction !== ''){
      // Simulate data loading
      setStepReadyState(false);
      setTimeout(() => {
          setStepReadyState(true); // Notify Joyride that the step is ready
      }, 200); // Adjust this delay to simulate your loading time || data?.resources[seriesDataKey]
    }
  }, [setStepReadyState]);

  const infoData = data?.resources || data?.resource;
  return (
    <CustomTooltip
      arrow
      sx={{
        zIndex: 99999999,
      }}
      placement="top"
      title={
        <Card
          sx={{
            height: "100%",
            background: "#EAFFD8",
            padding: 0,
            margin: 0,
          }}
        >
          <CardHeader
            sx={{ padding: "1rem" }}
            subheader={
              <Typography
                variant="h4"
                sx={{
                  fontFamily: "MADE TOMMY",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "17px",
                  letterSpacing: "0px",
                  textAlign: "left",
                  color: "#2B2B2B",
                  paddingBottom: "1rem",
                  textTransform: "capitalize",
                }}
              >
                {infoData?.caption_text}
              </Typography>
            }
          ></CardHeader>
          <Divider sx={{ border: "1px solid #164A1A" }} />
          <CardContent sx={{ padding: "1rem" }}>
            <div style={{ marginBottom: "15px" }}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "MADE TOMMY",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "14px",
                  letterSpacing: "0px",
                  textAlign: "left",
                  paddingBottom: "1rem",
                }}
              >
                {" "}
                Description{" "}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "MADE TOMMY",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {infoData?.description}
              </Typography>
            </div>
            <div style={{ padding: "0.5rem 0rem" }}>
              <Typography
                variant="div"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  color: "#2B2B2B",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                <span
                  sx={{
                    color: "#2B2B2B",
                    fontSize: "14px",
                    fontWeight: "500",
                    marginLeft: "1rem",
                  }}
                >
                  {" "}
                  Reporting period{" "}
                </span>
                <div style={{ display: "flex", alignItems: "center" }}>
                  &nbsp; &nbsp; &nbsp;
                  <img
                    src={tooltipCalender}
                    alt="calendar"
                    width="16px"
                    height="16px"
                  />
                  &nbsp;
                  <span
                    sx={{
                      color: "#2B2B2B",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    {" "}
                    {data?.formatted_timestamp}
                  </span>
                </div>
              </Typography>
              <Typography
                variant="div"
                sx={{
                  paddingTop: "10px",
                  color: "#2B2B2B",
                  fontSize: "13px",
                  fontWeight: "400",
                }}
              >
                {infoData?.citation}
              </Typography>
              {data?.glossary_resource && (
                <Typography variant="body1" sx={{ marginTop: "1rem" }}>
                  <a
                    href={readMore(data?.glossary_resource)}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "#164A1A",
                      textDecoration: "underline",
                      fontWeight: 500,
                      fontSize: "14px",
                    }}
                  >
                    Read more
                  </a>
                </Typography>
              )}
            </div>
          </CardContent>
        </Card>
      }
    >
      <IconButton
       ref={elementRef}
        disableRipple
        disableFocusRipple
        disableTouchRipple
        aria-owns={`mouse-over-popover`}
        aria-haspopup="true"
        className="my-twelve-step"
      >
        <InfoOutlinedIcon
          sx={{ color: "#919397", marginTop: "-10px" }}
          fontSize="small"
        />
      </IconButton>
    </CustomTooltip>
  );
};

export default InfoDataTooltip;
